import { createSlice } from '@reduxjs/toolkit';

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState: {
    open: false,
    message: '',
    autoHideDuration: 6000,
    anchorOrigin: {vertical: 'top', horizontal: 'right'},
  },
  reducers: {
    showSnackbar(state, action) {
      state.open = true;
      state.message = action.payload.message || '';
      state.autoHideDuration = action.payload.autoHideDuration || 6000;
      state.anchorOrigin = action.payload.anchorOrigin || {vertical: 'top', horizontal: 'right'};
    },
    hideSnackbar(state) {
      state.open = false;
      state.message = '';
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
